<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">User Detail</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <v-snackbar
          v-model="snackbar"
          :timeout="2000"
          color="success"
          top
          class="snackbar-center"
      >
        {{ snackbarMessage }}
      </v-snackbar>
      <b-row>
        <b-col v-if="id">
          <label for="userId">ID: </label>
          <b-form-input
            id="userId"
            disabled
            type="text"
            v-model="id"
          ></b-form-input>
        </b-col>
        <b-col>
          <label for="firstName">First Name: </label>
          <b-form-input
            id="firstName"
            type="text"
            v-model="form.firstName"
            placeholder="Enter Firstname"
            :class="{'input--error': firstNameError.show }"
          ></b-form-input>
          <div v-if="firstNameError.show" class="text-error">{{ firstNameError.message }}</div>
        </b-col>
        <b-col>
          <label for="lastName">Last Name: </label>
          <b-form-input
            id="lastName"
            type="text"
            v-model="form.lastName"
            placeholder="Enter Lastname"
            :class="{'input--error': lastNameError.show }"
          ></b-form-input>
          <div v-if="lastNameError.show" class="text-error">{{ lastNameError.message }}</div>
        </b-col>
        <b-col>
          <label for="emailInput">Email: </label>
          <b-form-input
            id="emailInput"
            type="text"
            v-model="form.email"
            placeholder="Enter Email"
            :class="{'input--error': emailNameError.show }"
          ></b-form-input>
          <div v-if="emailNameError.show" class="text-error">{{ emailNameError.message }}</div>
        </b-col>
      </b-row>
      <div class="d-flex flex-row my-4">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="form.active"
          id="flexCheckDefault"
        />
        <label class="form-check-label" for="flexCheckDefault"> Active </label>
      </div>
      <div class="permission-section">
        <div class="my-3">
          <span>Permissions</span>
          <div v-if="permissionsError.show" class="text-error">{{ permissionsError.message }}</div>
        </div>
        <div class="row my-4">
          <div class="checkbox-left col-3">
            <input
              class="form-check-input"
              type="checkbox"
              value="admin"
              id="admin"
              v-model="form.permissions"
              :disabled="isSelf && isAdmin && type === 'edit'"
            />
            <label class="form-check-label" for="admin"> Admin </label>
          </div>
          <div class="checkbox-right col">
            <input
              class="form-check-input"
              type="checkbox"
              value="brand_admin"
              id="brandAdmin"
              v-model="form.permissions"
            />
            <label class="form-check-label" for="brandAdmin">
              Brand admin
            </label>
          </div>
        </div>
        <div class="row my-4">
          <div class="checkbox-left col-3">
            <input
              class="form-check-input"
              type="checkbox"
              value="sales_supervisor"
              id="salesSupervisor"
              v-model="form.permissions"
            />
            <label class="form-check-label" for="salesSupervisor">
              Sales supervisor
            </label>
          </div>
          <div class="checkbox-left col-3">
            <input
              class="form-check-input"
              type="checkbox"
              value="bc"
              id="BC"
              v-model="form.permissions"
            />
            <label class="form-check-label" for="BC"> BC </label>
          </div>
        </div>
        <div class="row">
          <div class="checkbox-left col-3">
            <input
                class="form-check-input"
                type="checkbox"
                value="pos_staff"
                id="posStaff"
                v-model="form.permissions"
            />
            <label class="form-check-label" for="posStaff">
              POS staff
            </label>
          </div>
        </div>
      </div>
      <div class="row" v-if="form.permissions.includes('pos_staff')">
          <div class="col-3">
            <label for="staffCode" class="form-check-label"> Staff Code
              <span style="color: red;">*</span>
            </label>
            <b-form-input
                id="staffCode"
                type="text"
                v-model="form.staffCode"
                placeholder="Enter staffCode"
                :class="{'input--error': staffCodeError.show }"
            ></b-form-input>
            <div v-if="staffCodeError.show" class="text-error">{{ staffCodeError.message }}</div>
        </div>
      </div>
      <div class="row">
        <div class="my-3" v-if="shouldShowBrandsDropdown">
          <label for="brandMultiSelect" class="form-check-label">
            Brands
            <span v-if="form.permissions.includes('pos_staff')" style="color: red;">*</span>
          </label>
          <multiselect
            id="brandMultiSelect"
            v-model="form.brand"
            :options="listBrands"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Pick some"
            track-by="id"
            label="text"
            :class="{ 'input--error': brandError.show }"
          />
          <div v-if="brandError.show" class="text-error">{{ brandError.message }}</div>
        </div>
        <div class="my-3" v-if="shouldShowStoresDropdown">
          <label for="storeMultiSelect" class="form-check-label">
            Stores
            <span v-if="form.permissions.includes('pos_staff')" style="color: red;">*</span>
          </label>
          <multiselect
            id="storeMultiSelect"
            v-model="form.stores"
            :options="listStores"
            :multiple="true"
            placeholder="Pick some"
            track-by="storeCode"
            label="displayName"
            :class="{ 'input--error': storeError.show }"
          />
          <div v-if="storeError.show" class="text-error">{{ storeError.message }}</div>
        </div>
        <div class="my-3" v-if="mfaDevice">
          <label for="mfaDevice">MFA Device</label>
          <div v-if="mfaError" class="text-error">{{ mfaError }}</div>
          <div class="d-flex align-items-center flex-wrap gap-3">
            <div >
              <strong>Registration date:</strong> {{ formatDate(mfaDevice.dateCreated) }}
            </div>
              <button @click="confirmDelete" class="btn btn-danger" v-if="isAdminCurrentUser">
                Delete Device
              </button>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button
            @click="() => $router.push({ name: 'Users' })"
            class="btn btn-outline-danger btn-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-outline-success"
            @click="submitData"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && type === 'edit'">
            <button class="btn-back" @click="bindingData()">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="mt-5">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'Users' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn-back"
            @click="showDialog = false"
          >
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="isShowConfirmDialog" width="300" persistent>
      <div class="confirm-dialog">
        <p>
          Are you sure you want to <strong class="red--text">delete</strong> this MFA device?
        </p>
        <div class="text-center">
          <button class="btn-back mr-5" @click="deleteDevice">ใช่</button>
          <button class="btn-back" @click="hideConfirmDialog">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import UserService from "@/services/api/user.service";
import BrandService from "@/services/api/brand.service";
import StoreService from "services/api/store.service";
import moment from "moment/moment";
import MfaService from "services/api/mfa.service";
import {TokenService} from "services/storage.service";
import ErrorFields from "@/views/Survey/errorFields";

export default {
  data() {
    let query = this.$route.query;
    const userId = query.id;
    const type = query.type;
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        active: false,
        permissions: [],
        brand: [],
        stores: [],
        staffCode: "",
      },
      errorMsg: {
        errFirstName: null,
        errLastName: null,
        errEmail: null,
        errPermissions: null,
        errBrand: null,
        errStore: null,
        errStaffCode: null,
      },
      id: userId,
      listBrands: [],
      listStores: [],
      isSubmit: false,
      isLoading: false,
      showDialog: false,
      showSuccess: false,
      isAdmin: false,
      message: "Test Something",
      type,
      isSelf: false,
      mfaDevice: null,
      mfaError: "",
      snackbar: false,
      snackbarMessage: "",
      isShowConfirmDialog: false,
      isAdminCurrentUser: false,
      isBinding: false,
      isBootstrapping: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    await this.getListBrands();
    await this.getListStores();

    if (this.id) {
      await this.bindingData();
    } else {
      this.isLoading = false;
    }

    const userRole = JSON.parse(TokenService.getUserRoles());
    this.isAdminCurrentUser = userRole.includes("ROLE_ADMIN");
  },
  computed: {
    brandIds() {
      return this.form.brand.map((brand) => brand.id);
    },
    shouldShowBrandsDropdown() {
      const permissions = this.form.permissions;
      const onlyAdmin = permissions.length === 1 && permissions[0] === 'admin';
      return !onlyAdmin;
    },
    shouldShowStoresDropdown() {
      const permissions = this.form.permissions;
      const onlyAdminRoles = permissions.length > 0 &&
          permissions.every(p => p === 'admin' || p === 'brand_admin');
      return !onlyAdminRoles;
    },
    firstNameError() {
      return this.setValidateNullErrorMsg(
        "errFirstName",
        "First Name",
        this.form.firstName
      );
    },
    lastNameError() {
      return this.setValidateNullErrorMsg(
        "errLastName",
        "Last Name",
        this.form.lastName
      );
    },
    emailNameError() {
      return this.setValidateNullErrorMsg(
        "errEmail",
        "Email",
        this.form.email
      );
    },
    staffCodeError() {
      return this.setValidateNullErrorMsg(
        "errStaffCode",
        "Staff Code",
        this.form.staffCode,
        true
      );
    },
    brandError() {
      return this.setValidateNullErrorMsg(
        "errBrand",
        "Brands",
        this.form.brand,
        true
      );
    },
    storeError() {
      return this.setValidateNullErrorMsg(
        "errStore",
        "Stores",
        this.form.stores,
        true
      );
    },
    permissionsError() {
      return this.setValidateNullErrorMsg(
          "errPermissions",
          "Permissions",
          this.form.permissions
      );
    },
  },
  methods: {
    async getListBrands() {
      try {
        await BrandService.getListBrands()
          .then((res) => {
            const data = res.data;
            this.listBrands = data.brand.map((i) => {
              return {
                id: i.code,
                text: i.name,
              };
            });
          })
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    async getListStores() {
      try {
        const brandIds = this.form.brand
          ? this.form.brand.map((brand) => brand.id)
          : [];
        const params = {
          brands: brandIds,
        };

        await StoreService.getListStore(params).then((res) => {
          const data = res.data;
          this.listStores = data.store.map((i) => {
            return {
              storeCode: i.storeCode,
              displayName: i.displayName,
            };
          });
        });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    async bindingData() {
      this.setDefault();
      this.isBinding = true;
      this.isBootstrapping = true;

      if (!this.showDialog) {
        this.isLoading = true;
      }

      try {
        const res = await UserService.getDetailUsers(this.id);

        const userDetail = res.data.userDetail || {};
        const userBrands = Array.isArray(userDetail.brands) ? userDetail.brands : [];
        const userStores = Array.isArray(userDetail.stores) ? userDetail.stores : [];
        const permissions = Array.isArray(userDetail.permissions) ? userDetail.permissions : [];
        const mfaDevices = Array.isArray(userDetail.mfaDevices) ? userDetail.mfaDevices : [];

        const selectedBrands = (this.listBrands || []).filter(b => userBrands.includes(b?.id));

        this.form.brand = selectedBrands;

        await this.getListStores();

        const selectedStores = (this.listStores || []).filter(s => userStores.includes(s?.storeCode));

        const admin = permissions.find(p => String(p).toLowerCase() === 'admin');
        this.isSelf = !!userDetail.isSelf;
        this.isAdmin = !!admin;
        this.mfaDevice = mfaDevices[0] || null;

        this.form = {
          id: userDetail.id ?? null,
          brand: selectedBrands,
          stores: selectedStores,
          permissions: permissions.map(p => String(p).toLowerCase()),
          firstName: userDetail.firstname ?? '',
          lastName: userDetail.lastname ?? '',
          email: userDetail.email ?? '',
          active: userDetail.status ?? false,
          staffCode: userDetail.staffCode ?? '',
        };
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      } finally {
        this.isBootstrapping = false;
        this.isBinding = false;
        this.isLoading = false;
      }
    },
    submitData() {
      const form = this.form;
      this.isSubmit = true;
      this.showSuccess = false;
      this.resetErrorText();
      this.isAdmin = form.permissions?.find((s) => s === "admin");
      if (form.firstName === "" || form.lastName === "" || form.email === "") {
        return;
      }

      if (form.permissions.includes("pos_staff") && form.staffCode === "") {
        form.staffCode = null;
      }

      if (!form.permissions.includes("pos_staff")) {
        form.staffCode = null;
      }

      const body = {
        firstname: form.firstName,
        lastname: form.lastName,
        email: form.email,
        permissions: form.permissions,
        brand: form.brand?.map((s) => {
          return s.id.toString();
        }),
        stores: form.stores?.map((i) => {
          return i.storeCode;
        }),
        status: form.active ? "active" : "inactive",
        staffCode: form.staffCode,
      };
      if (this.id) {
        this.editUser(body);
      } else {
        this.addUser(body);
      }
    },
    async addUser(body) {
      this.isLoading = true;
      try {
        await UserService.createUsers(body)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.setMsgDialog(data.message);
            if (data.status === "failure") {
              this.setApiErrorMsg(data.errors);
            } else {
              this.showDialog = true;
              this.showSuccess = true;
            }
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async editUser(body) {
      this.isLoading = true;
      try {
        await UserService.updateUsers(this.id, body)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.setMsgDialog(data.message);
            if (data.status === "failure") {
              this.setApiErrorMsg(data.errors);
            } else {
              this.showDialog = true;
              this.showSuccess = true;
            }
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    setMsgDialog(message) {
      this.message = message;
    },
    setApiErrorMsg(errors) {
      this.errorMsg.errFirstName = errors?.find(
        (e) => e.field_name === "firstname"
      );
      this.errorMsg.errLastName = errors?.find(
        (e) => e.field_name === "lastname"
      );
      this.errorMsg.errEmail = errors?.find((e) => e.field_name === "email");
      this.errorMsg.errPermissions = errors?.find((e) => e.field_name === "permissions");
      this.errorMsg.errBrand = errors?.find((e) => e.field_name === "brand");
      this.errorMsg.errStore = errors?.find((e) => e.field_name === "stores");
      this.errorMsg.errStaffCode = errors?.find((e) => e.field_name === "staffCode");
    },
    setValidateNullErrorMsg(errorKey, errorFieldName, value, isPosStaff = false) {
      const hasPermission = this.form.permissions.includes("pos_staff");
      const hasBackendError = !!this.errorMsg[errorKey];
      const isEmpty =
        Array.isArray(value) ? value.length === 0 : !value?.trim?.();

      const shouldShow = isPosStaff
        ? (this.isSubmit && hasPermission && isEmpty) || hasBackendError
        : (this.isSubmit && isEmpty) || hasBackendError;

      return {
        show: shouldShow,
        message:
          this.isSubmit &&
          ((isPosStaff && hasPermission && isEmpty) || (!isPosStaff && isEmpty))
            ? `Please specify ${errorFieldName}`
            : this.errorMsg[errorKey]?.message || "",
      };
    },
    resetErrorText() {
      this.errorMsg = {
        ...ErrorFields,
      };
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    hideDialog() {
      this.showDialog = false;
    },
    confirmDelete() {
      this.showConfirmDialog();
    },
    showConfirmDialog() {
      this.isShowConfirmDialog = true;
    },
    hideConfirmDialog() {
      this.isShowConfirmDialog = false;
    },
    async deleteDevice() {
      this.isLoading = true;
      try {
        const res = await MfaService.deleteAdminMFA(this.mfaDevice.id);
        this.isLoading = false;
        if (res.status === 204) {
          this.mfaDevice = null;
          this.snackbarMessage = 'ลบ MFA Device เรียบร้อย!'
          this.isShowConfirmDialog = false;
          this.snackbar = true
        }
      } catch (error) {
        console.error("Failed to delete device:", error)
        this.mfaError = "Failed to delete device"
      }
    },
    formatDate(dateStr) {
     return moment(dateStr).format("DD/MM/YYYY HH:mm:ss")
    }
  },
  watch: {
    async brandIds(newVal, oldVal) {
      if (this.isBootstrapping || newVal === oldVal) {
        return;
      }

      if ((oldVal?.length || 0) > 0 && (newVal?.length || 0) === 0) {
        this.form.stores = [];
        return;
      }

      const currentSelectedStores = [...this.form.stores];
      await this.getListStores();
      this.form.stores = this.listStores.filter((store) =>
        currentSelectedStores.find((selectedStore) => selectedStore.storeCode === store.storeCode)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  min-height: 20vh;
  margin: 3rem 3rem;
  position: relative;
}
.rounded {
  border-radius: 1rem !important;
}
.form-check-input {
  margin-right: 0.5rem;
}

.input--error {
  border-color: red !important;
}
.btn {
  margin: 0 1rem;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}

.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
.permission-section {
  padding: 2rem 0;
}

.snackbar-center{
  max-width: 300px !important;
  left: 50% !important;
  color: black ;
  text-align: center;
}

.confirm-dialog {
  left: 50% !important;
  background: #fff;
  padding: 2rem 2rem;

  p {
    font-size: 20px;
    padding-bottom: 2rem;
    text-align: center;
    font-weight: bold;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}

.required {
  color: red; /* Highlight required label */
  font-weight: bold;
}
</style>
